// extracted by mini-css-extract-plugin
module.exports = {"discoverways":"AlumniDiscoverWays_discoverways__Ncfus"};